import {
  feet,
  identity,
  kilometers,
  miles,
  nauticalMiles,
} from './conversions.js';
import formatNumber, {DEFAULT_FORMAT, truncateNumber} from './format-number.js';
import {getLength} from './geodetic.js';

import {distanceUnits} from '@app/constants';

const conversionMap = {
  [distanceUnits.metric.m]: n => truncateNumber(identity(n)),
  [distanceUnits.metric.km]: n => truncateNumber(kilometers(n)),
  [distanceUnits.usc.ft]: n => truncateNumber(feet(n)),
  [distanceUnits.usc.mi]: n => truncateNumber(miles(n)),
  [distanceUnits.usc.nmi]: n => truncateNumber(nauticalMiles(n)),
};

export const localizationMap = {
  [distanceUnits.metric.m]: 'm',
  [distanceUnits.metric.km]: 'km',
  [distanceUnits.usc.ft]: 'ft',
  [distanceUnits.usc.mi]: 'mi',
  [distanceUnits.usc.nmi]: 'nm',
};

const formatDistance = (
  lineString,
  unit = distanceUnits.metric.m,
  format = DEFAULT_FORMAT,
  lengthOptions
) => {
  if (!conversionMap[unit]) {
    return '';
  }

  const meters = getLength(lineString, lengthOptions);
  return formatNumber(meters, conversionMap[unit], format);
};

export default formatDistance;
